var _rect, _rect2, _g, _rect3, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstgramImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.65,
    y: 0.65,
    width: 46.7,
    height: 46.7,
    rx: 4.35,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.65,
    y: 0.65,
    width: 46.7,
    height: 46.7,
    rx: 4.35,
    stroke: "#DBDEE1",
    strokeWidth: 1.3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.25,
    filter: "url(#filter0_f_4462_27493)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9.5918,
    y: 24,
    width: 28.0945,
    height: 17.5591,
    rx: 8.77954,
    fill: "url(#paint0_linear_4462_27493)"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8.74023,
    y: 8.74219,
    width: 30.4357,
    height: 30.4357,
    rx: 12.3724,
    fill: "url(#paint1_linear_4462_27493)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4462_27493)",
    filter: "url(#filter1_i_4462_27493)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_4462_27493)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.8668 32.5877C31.1142 32.1057 32.1004 31.1196 32.5823 29.8722C32.8105 29.2813 32.9702 28.6071 33.0135 27.6209C33.0238 27.3899 33.0318 27.196 33.0392 27.0015V20.4126C33.034 20.2752 33.0283 20.132 33.0209 19.9712C32.9776 18.985 32.8179 18.3074 32.5897 17.7199C32.3542 17.0965 31.9914 16.5381 31.5169 16.0744C31.0526 15.6027 30.4908 15.2366 29.8742 15.005C29.2833 14.7769 28.6091 14.6172 27.623 14.5738C26.6294 14.5265 26.314 14.5156 23.7947 14.5156C21.2754 14.5156 20.9594 14.5265 19.9698 14.5698C18.9836 14.6132 18.306 14.7729 17.7186 15.001C17.0951 15.2366 16.5368 15.5993 16.0725 16.0744C15.6014 16.5387 15.2352 17.1005 15.003 17.7165C14.7749 18.3074 14.6152 18.9816 14.5718 19.9678C14.5245 20.9613 14.5137 21.2768 14.5137 23.7966C14.5137 26.3165 14.5245 26.6319 14.5679 27.6215C14.6112 28.6077 14.7709 29.2858 14.9996 29.8727C15.2352 30.4962 15.6014 31.0545 16.0725 31.5188C16.5368 31.9899 17.0986 32.3567 17.7151 32.5883C18.306 32.8164 18.9802 32.9761 19.9664 33.0195C20.956 33.0634 21.2714 33.0742 23.7913 33.0742C26.3111 33.0742 26.626 33.0634 27.6161 33.0195C28.6023 32.9761 29.2799 32.8164 29.8674 32.5883L29.8668 32.5877ZM23.7981 31.4059C21.3216 31.4059 21.0244 31.3951 20.0491 31.3517C19.1428 31.3118 18.6534 31.1595 18.3271 31.0329C17.925 30.884 17.5589 30.6484 17.2611 30.3404C16.9531 30.0393 16.717 29.6771 16.5687 29.2744C16.4421 28.9482 16.2898 28.4548 16.2499 27.5525C16.2065 26.5737 16.1957 26.28 16.1957 23.8035C16.1957 21.3269 16.2065 21.0298 16.2499 20.055C16.2898 19.1487 16.4421 18.6593 16.5687 18.3331C16.7176 17.9304 16.9531 17.5642 17.2651 17.2671C17.5657 16.9591 17.9285 16.7235 18.3306 16.5746C18.6568 16.448 19.1502 16.2957 20.0525 16.2558C21.0313 16.2125 21.325 16.2016 23.801 16.2016C26.2769 16.2016 26.5746 16.2125 27.55 16.2558C28.4563 16.2957 28.9457 16.448 29.2719 16.5746C29.674 16.7235 30.0402 16.9591 30.3374 17.2671C30.6454 17.5682 30.8815 17.9304 31.0298 18.3331C31.1564 18.6593 31.3087 19.1521 31.3486 20.055C31.392 21.0338 31.4028 21.3275 31.4028 23.8035C31.4028 26.2794 31.392 26.5698 31.3486 27.5485C31.3087 28.4548 31.1564 28.9442 31.0298 29.2704C30.7178 30.0792 30.0761 30.7209 29.2679 31.0323C28.9417 31.1589 28.4489 31.3112 27.546 31.3511C26.5672 31.3945 26.2735 31.4053 23.7975 31.4053L23.7981 31.4059Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.795 19.0273C21.1628 19.0273 19.0273 21.1628 19.0273 23.795C19.0273 26.4273 21.1628 28.5627 23.795 28.5627C26.4273 28.5627 28.5622 26.4273 28.5622 23.795C28.5622 21.1628 26.4267 19.0273 23.795 19.0273ZM23.795 26.887C22.0874 26.887 20.7025 25.5021 20.7025 23.7945C20.7025 22.0868 22.0874 20.7019 23.795 20.7019C25.5027 20.7019 26.8876 22.0868 26.8876 23.7945C26.8876 25.5021 25.5027 26.887 23.795 26.887Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8629 18.8393C29.8629 18.2245 29.3644 17.7266 28.7495 17.7266C28.1346 17.7266 27.6367 18.2251 27.6367 18.8393C27.6367 19.4536 28.1352 19.9521 28.7495 19.9521C29.3638 19.9521 29.8629 19.4542 29.8629 18.8393Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_4462_27493",
    x: 4.1318,
    y: 18.54,
    width: 39.0138,
    height: 28.4786,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.73,
    result: "effect1_foregroundBlur_4462_27493"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_4462_27493",
    x: 14.5137,
    y: 14.5156,
    width: 18.5586,
    height: 18.7648,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.206207
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.515516
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4462_27493"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_4462_27493",
    x: 14.5137,
    y: 14.5156,
    width: 18.5254,
    height: 19.0586,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4462_27493"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4462_27493",
    x1: 23.6391,
    y1: 23.4529,
    x2: 23.6391,
    y2: 42.4793,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCA759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#E82D56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#A22DB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#643DCE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4462_27493",
    x1: 23.9581,
    y1: 7.79384,
    x2: 23.9581,
    y2: 40.7729,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCA759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#E82D56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#A22DB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#643DCE"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4462_27493"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.5586,
    height: 18.5586,
    fill: "white",
    transform: "translate(14.5137 14.5156)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstgramImg);
export default __webpack_public_path__ + "static/media/instgram-img.26670732d7f94317f6690dea7fddccd5.svg";
export { ForwardRef as ReactComponent };